import { takeLatest } from 'redux-saga/effects';

import { fetchSaga } from './helper';
import { fetchItemTypesRoutine } from '../routines';
import { getAccountPath } from '../../utils/firebase';

function* watchFetchItemTypesSaga() {
  yield takeLatest(fetchItemTypesRoutine.TRIGGER, fetchSaga(fetchItemTypesRoutine, () => getAccountPath('itemtypes')));
}

export {
  watchFetchItemTypesSaga,
  // fetchItemSaga,
  // watchFetchItemSaga,
};



// WEBPACK FOOTER //
// ./src/redux/sagas/itemtypes.js